import { normalizePath } from './utils'
import type { LocalFileEntry } from './types'

export function buildLocalIndex(fileList: FileList, rootLabel = 'Локальная папка'): {
  rootLabel: string
  entries: LocalFileEntry[]
} {
  const entries: LocalFileEntry[] = []
  const dirPaths = new Set<string>()

  Array.from(fileList).forEach((file) => {
    const rel = (file as File & { webkitRelativePath?: string }).webkitRelativePath || file.name
    const parts = rel.split('/').filter(Boolean)
    for (let i = 1; i < parts.length; i++) {
      dirPaths.add(`/${parts.slice(0, i).join('/')}`)
    }
    const filePath = `/${rel}`
    entries.push({
      name: parts[parts.length - 1] || file.name,
      path: filePath,
      type: 'file',
      size: file.size,
      file,
      modifyTime: file.lastModified,
    })
  })

  dirPaths.forEach((dirPath) => {
    const name = dirPath.split('/').filter(Boolean).pop() || dirPath
    if (!entries.some((e) => e.path === dirPath)) {
      entries.push({ name, path: dirPath, type: 'directory', size: 0 })
    }
  })

  return { rootLabel, entries }
}

export function addLocalFiles(
  entries: LocalFileEntry[],
  dirPath: string,
  files: File[],
): LocalFileEntry[] {
  const next = [...entries]
  const base = normalizePath(dirPath)
  for (const file of files) {
    const filePath = base === '/' ? `/${file.name}` : `${base}/${file.name}`
    const idx = next.findIndex((e) => e.path === filePath)
    const entry: LocalFileEntry = {
      name: file.name,
      path: filePath,
      type: 'file',
      size: file.size,
      file,
      modifyTime: file.lastModified,
    }
    if (idx >= 0) next[idx] = entry
    else next.push(entry)
  }
  return next
}

export function getLocalChildren(entries: LocalFileEntry[], dirPath: string): LocalFileEntry[] {
  const normalized = normalizePath(dirPath)
  const seen = new Set<string>()
  const result: LocalFileEntry[] = []

  for (const e of entries) {
    if (e.path === normalized) continue

    let rel: string
    if (normalized === '/') {
      if (!e.path.startsWith('/')) continue
      rel = e.path.slice(1)
    } else {
      if (!e.path.startsWith(`${normalized}/`)) continue
      rel = e.path.slice(normalized.length + 1)
    }

    const firstSeg = rel.split('/').filter(Boolean)[0]
    if (!firstSeg || seen.has(firstSeg)) continue
    seen.add(firstSeg)

    const childPath = normalized === '/' ? `/${firstSeg}` : `${normalized}/${firstSeg}`
    const direct = entries.find((x) => x.path === childPath)
    if (direct) {
      result.push(direct)
    } else {
      result.push({ name: firstSeg, path: childPath, type: 'directory', size: 0 })
    }
  }

  return result
}

export function getLocalFile(entries: LocalFileEntry[], filePath: string) {
  return entries.find((e) => e.path === filePath && e.type === 'file')
}
